export type ProviderType = 'SweHockey';

export const SWE_HOCKEY_WIDGET_TYPES = {
  MatchStatus: 'game.status',
  MatchinfoGeneralInfo: 'game.information',
  Lineup: 'game.information.players',
  Events: 'game.information.events',
  TeamCaptain: 'game.information.officials',
  Referees: 'game.information.referees',
  GamePreview: 'game.preview.total',
  PeriodStatistics: 'game.statistics.periods',
  TotalStatistics: 'game.statistics.total',
  LiveTable: 'standings.game.total',
  LiveTableDropdown: 'standings.game.tournament',
} as const;

export type WidgetTypes = keyof typeof SWE_HOCKEY_WIDGET_TYPES;

export type SweHockeyContentObject = {
  provider: 'SweHockey';
  type: WidgetTypes;
  viewProps?: {
    renderGeneralMatchInfo?: boolean;
    shouldRegisterSocket?: boolean;
  };
};
